import React, {useState, useCallback, useEffect} from "react";
import { useTranslation, Trans, I18nextContext } from 'gatsby-plugin-react-i18next';
import './header.scss';
import TransitionLink from "gatsby-plugin-transition-link/"
import logo from "../../images/logo.svg";
import logoWhite from "../../images/logo-white.svg";
import imageCodeWe from "../../images/modal/code-we.jpg";
import {ModalOverlay} from '../modal-overlay/modal-overlay';

// Defining the <Greeting> component
export const Header = (props) => {
  const { t } = useTranslation();
  let showWechat = t('showWechat') === 'true';
  const [visible, setVisible] = useState(false);
  const [overlayCode, setVisibleCode] = useState(false);
  const [playAudio, setPlayAudio] = useState(false);
  const [pauseAudio, setPauseAudio] = useState(null);
  const titleWe = t('title modal we');

  const context = React.useContext(I18nextContext);
  let lang = context.language;

  let imgCode = null;
  if(t('wechat') === 'true') {
    imgCode = imageCodeWe;
  }

  useEffect(() => {
    
    if(window.innerWidth >= 768) {
      const audioSound = document.querySelector('#soundId')
      if(audioSound) {
        if(audioSound.paused){
            setPlayAudio(false)
        }else{
            setPlayAudio(true)
        }
      }
    }
  }, [])

  let toggleShare = (isShowing) => {
    if(!isShowing){
      setTimeout(() => {
        setVisible(isShowing);
        setVisibleCode(false);
      }, 600);
    }else {
      setVisible(isShowing);
    }
  };
  const openOverlay = useCallback(
    (e) => {
      e.preventDefault();
      setVisibleCode(true);
    },
    []
  );

  const onCloseOverlay = useCallback(
    (e) => {
      e.preventDefault();
      setVisibleCode(false);
    },
    []
  );

  const controlAudio = useCallback(
    () => {
      if(window.innerWidth >= 768) {
        const audioSound = document.querySelector('#soundId')
        if(audioSound) {
          if(audioSound.paused){
              audioSound.play();
              if(props.setPlayAudio) {
                props.setPlayAudio(true)
                setPlayAudio(true)
                setPauseAudio(false)
              } else {
                setPlayAudio(true)
                setPauseAudio(false)
              }
          }else{
              audioSound.pause();
              if(props.setPlayAudio) {
                props.setPlayAudio(false)
                setPlayAudio(false)
                setPauseAudio(true)
              } else {
                setPlayAudio(false)
                setPauseAudio(true)
              }
          }
        }
      }
    },
    [],
  )
  let isChina = lang === 'zh_hans' || lang === 'zh_hant' ? true : false;

  function exitAnim(){
    document.body.classList.add('glitch-anim')
  }

  function entryAnim(){
    document.body.classList.remove('glitch-anim')
  }


  let location = typeof window !== "undefined" ? window.location.href : '';
  let title = typeof document !== "undefined" ? document.title : '';


  return (
      <div className="header">
        {
          (!props.teaser && !isChina) &&
          <div className={`header__item header__item--share ${props.hasHeaderWhite ? 'header--white' : ''}` }>
          <button 
            className={`${visible ? 'header__link--hidden' : ''} header__link ` }
            onClick={() => toggleShare(true)}>
            <Trans>Share on</Trans>
            <svg fill="none" viewBox="0 0 10 8" className="header__linkSvg">
              <path d="m6.6667-7.9499e-8 -3.3333 3.3684 0.3125 0.31579 2.1042-2.1263c0.05824-0.0577 0.13195-0.09686 0.21201-0.11262 0.08005-0.01577 0.16293-0.00744 0.23834 0.02394 0.07542 0.03138 0.14007 0.08444 0.18593 0.15259 0.04585 0.06816 0.07091 0.14842 0.07205 0.23083v4.0421c0.00318 0.22218-0.03757 0.44276-0.11985 0.64882s-0.20444 0.39345-0.35931 0.55118c-0.31751 0.31279-0.74409 0.48673-1.1875 0.48421h-4.7917l5.021e-9 0.42105h4.7917c0.55231-0.00416 1.0819-0.22275 1.4792-0.61053 0.38375-0.40144 0.60006-0.9366 0.60417-1.4947v-4.0421c0.00115-0.08241 0.0262-0.16267 0.07206-0.23083 0.04586-0.06815 0.1105-0.12121 0.18592-0.15259s0.15829-0.03971 0.23835-0.02394c0.08005 0.01576 0.15377 0.05492 0.212 0.11262l2.1042 2.1263 0.3125-0.31579-3.3333-3.3684z" fill="#000"/>
            </svg>
          </button>
          <ul className={`${visible ? '' : 'share__list--hidden'} share__list`}
          onMouseLeave={() => toggleShare(false)}>
            <li className="share__item">
              <a target="_blank" 
                href={`https://www.facebook.com/sharer/sharer.php?u=${location}&amp;src=sdkpreparse`}
                className="share__link"
                tabIndex={`${visible ? '1' : '-1'}`}
                >
                <span className="share__itemIcon i-FB"></span>
                <span className="share__txt">Share on FB</span>
              </a>
            </li>
            <li className="share__item">
              <a target="_blank" 
                href={`http://www.twitter.com/share?url=${location}`}
                className="share__link"
                tabIndex={`${visible ? '0' : '-1'}`}>
                <span className="share__itemIcon i-twitter"></span>
                <span className="share__txt">Share on Twitter</span>
              </a>
            </li>
            <li className="share__item">
              <a target="_blank" 
                href={`https://www.linkedin.com/shareArticle?mini=true&url=${location}&title=${title}&source=LoroPiana`}
                className="share__link"
                tabIndex={`${visible ? '0' : '-1'}`}>
                <span className="share__itemIcon i-linkedin"></span>
                <span className="share__txt">Share on linkdn</span>
              </a>
            </li>
            { showWechat &&
              <li className="share__item">
                <a target="_blank" 
                  href="#"
                  className="share__link"
                  tabIndex={`${visible ? '0' : '-1'}`}
                  onClick={openOverlay}>
                  <span className="share__itemIcon i-wechat"></span>
                  <span className="share__txt">Share on wechat</span>
                </a>  
                <ModalOverlay stateOverlay={overlayCode} codeImage='true'  titleModal={titleWe} onCloseOverlay={onCloseOverlay} srcCode={imgCode}></ModalOverlay>
                </li>
              }
          </ul>
        </div>
        }

          <div className=" header__logo">
            { props.hasLogoWhite ? 
            (
              <TransitionLink className = "header__logoLink"
              exit={{
                length: 0.8,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.8,
                trigger: ({ entry, node }) =>  entryAnim(entry, node),
              }}
              to={"/" + lang + '/'}  >
                 <img className=" header__logoImg" src={logoWhite} alt={`${t('logoAlt')}`} />
                <h1 className="visually-hidden"><Trans>h1</Trans></h1>
              </TransitionLink>
            ):(
              <TransitionLink className = "header__logoLink"
              exit={{
                length: 0.8,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.8,
                trigger: ({ entry, node }) =>  entryAnim(entry, node),
              }}
              to={"/" + lang + '/'}  >
                 <img className=" header__logoImg" src={logo} alt={`${t('logoAlt')}`} />
                <h1 className="visually-hidden"><Trans>h1</Trans></h1>
              </TransitionLink>
            )
          }
          </div>
          {/* {
            !props.teaser &&

              <div className="header__item header__item--withSound header__item--link">
                <a href="#" className={`${props.playAudio || playAudio ? 'header__sound--play' : ''} ${pauseAudio ? 'header__sound--pause' : ''} header__sound j-audioBar`} onClick={controlAudio}>
                  <span className="header__soundTxt"><Trans>Sound</Trans></span>
                  <div className="header__soundIcon">
                    <span className="header__soundBar"></span>
                    <span className="header__soundBar"></span>
                    <span className="header__soundBar"></span>
                    <span className="header__soundBar"></span>
                    <span className="header__soundBar"></span>
                    <span className="header__soundBar"></span>
                  </div>
                </a>
                <a href={`${t('urlLoroPiana')}`} className="header__button" target="_blank">
                  <Trans>Visit LoroPiana</Trans>
                  <svg fill="none" viewBox="0 0 7 7" className="header__buttonSvg">
                    <path d="m1.9077 0.38184 4.7388-0.024811-0.02481 4.7389-0.44427 0.00232 0.01566-2.9914c-3.8e-4 -0.08198-0.02481-0.1618-0.07027-0.22955-0.04546-0.06776-0.10994-0.12047-0.18546-0.15161s-0.15875-0.03933-0.23937-0.02356c-0.08062 0.01576-0.15509 0.0548-0.21417 0.11226l-4.9795 4.9795-0.29463-0.29463 4.9795-4.9795c0.05746-0.05908 0.0965-0.13355 0.11227-0.21417 0.01576-0.08062 0.00757-0.16385-0.02357-0.23937-0.03114-0.075514-0.08385-0.14-0.15161-0.18546-0.06775-0.04546-0.14757-0.069894-0.22955-0.070274l-2.9914 0.015662 0.00233-0.44427z" fill="#fff"/>
                  </svg>
                </a>
              </div>
          } */}
          
          <div className="header__item header__item--withSound header__item--link">
            <a href="#" className={`${props.playAudio || playAudio ? 'header__sound--play' : ''} ${pauseAudio ? 'header__sound--pause' : ''} header__sound j-audioBar`} onClick={controlAudio}>
              <span className="header__soundTxt"><Trans>Sound</Trans></span>
              <div className="header__soundIcon">
                <span className="header__soundBar"></span>
                <span className="header__soundBar"></span>
                <span className="header__soundBar"></span>
                <span className="header__soundBar"></span>
                <span className="header__soundBar"></span>
                <span className="header__soundBar"></span>
              </div>
            </a>
            <a href={`${t('urlAltLoroPiana')}`} className="header__button">
              <Trans>Discover the collection</Trans>
              <svg fill="none" viewBox="0 0 7 7" className="header__buttonSvg">
                <path d="m1.9077 0.38184 4.7388-0.024811-0.02481 4.7389-0.44427 0.00232 0.01566-2.9914c-3.8e-4 -0.08198-0.02481-0.1618-0.07027-0.22955-0.04546-0.06776-0.10994-0.12047-0.18546-0.15161s-0.15875-0.03933-0.23937-0.02356c-0.08062 0.01576-0.15509 0.0548-0.21417 0.11226l-4.9795 4.9795-0.29463-0.29463 4.9795-4.9795c0.05746-0.05908 0.0965-0.13355 0.11227-0.21417 0.01576-0.08062 0.00757-0.16385-0.02357-0.23937-0.03114-0.075514-0.08385-0.14-0.15161-0.18546-0.06775-0.04546-0.14757-0.069894-0.22955-0.070274l-2.9914 0.015662 0.00233-0.44427z" fill="#fff"/>
              </svg>
            </a>
          </div>
      </div>
    )
  }